<template>
  <div>
    <h2>{{ header }}</h2>
    <v-select
      :label="$t('settings.workflow.delegationTaskEquals')"
      v-if="type === 'delegationTaskEquals'"
      style="width: 300px; display: inline-block;"
      :items="delegation_tasks"
      item-text="name"
      item-value="id"
      multiple
      small-chips
      deletable-chips
      v-model="contextParams"
    />
    <v-select
      :label="$t('settings.workflow.delegationCostCentreEquals')"
      v-if="type === 'delegationCostCentreEquals'"
      style="width: 300px; display: inline-block;"
      small-chips
      multiple
      deletable-chips
      :items="cost_centres"
      item-text="name"
      item-value="id"
      v-model="contextParams"
    />
    <amount-input
      v-if="type === 'delegationOverallCostAbove'"
      :label="$t('settings.workflow.delegationOverallCostAbove')"
      style="width: 300px; display: inline-block;"
      :rules="[v => !!v || $t('global.required')]"
      :model.sync="contextParams"
    />
  </div>
</template>

<script>
import AmountInput from "./CustomInputComponents/AmountInput";
export default {
  name: "WorkflowItemTypeAndParams",
  components: { AmountInput },
  props: {
    type: {
      required: true
    },
    params: {
      required: true
    }
  },
  methods: {},
  computed: {
    workflowOptions() {
      return [
        { text: this.$t("$staticData.workflow.start"), value: "start" },
        { text: this.$t("$staticData.workflow.acceptationBySpecifiedUsers"), value: "acceptationBySpecifiedUsers" },
        { text: this.$t("$staticData.workflow.delegationTaskEquals"), value: "delegationTaskEquals" },
        { text: this.$t("$staticData.workflow.delegationCostCentreEquals"), value: "delegationCostCentreEquals" },
        { text: this.$t("$staticData.workflow.delegationOverallCostAbove"), value: "delegationOverallCostAbove" }
      ];
    },
    contextParams: {
      set(val) {
        this.$emit("update:params", val);
      },
      get() {
        return this.params;
      }
    },
    header() {
      if (typeof this.workflowOptions.find(v => v.value === this.type) !== "undefined") {
        return this.workflowOptions.find(v => v.value === this.type).text;
      }
      return "";
    },
    delegation_tasks() {
      return this.$store.state.Settings.workflowData.delegation_tasks;
    },
    cost_centres() {
      return this.$store.state.Settings.workflowData.cost_centres;
    }
  }
};
</script>

<style scoped />
